module.exports = __webpack_public_path__ + "img/zaytsev.48c8a1f8.jpg";